import styled, { css } from "styled-components";
import { lighten } from "polished";

import { IDropStyleProps, IPlaygroundStyleProps } from "./interfaces";

export const Drop = styled.div<IDropStyleProps>`
    position: absolute;
    width: 20px;
    height: 20px;
    transition: 0.2s;
    box-shadow: 0 0 0 ${p => p.scale * 2}px black inset;
    border-radius: ${p => p.scale * 20}px;
    background-color: white;

    &.Christmas {
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 0;
        box-shadow: none;
        backdrop-filter: blur(4px);
    }

    &.Active {
        background-color: ${p => p.theme.c.disabled};
    }

    &.Playing {
        background-color: ${p => lighten(0.3, p.theme.c.play)};
    }
`;

export const Drag = styled.div`
    &.CheckPlayingBar {
        > div {
            background-color: ${p => p.theme.c.check} !important;

            path,
            rect,
            circle {
                fill: white;
            }

            line {
                stroke: white;
            }
        }
        > div.Christmas {
            background-color: ${p => lighten(0.1, p.theme.c.christmasBlue)} !important;
        }
    }
    &.PlayingBar {
        > div {
            background-color: ${p => p.theme.c.playLight} !important;
        }
    }
    .Disabled {
        pointer-events: none;
    }
`;

export const Playground = styled.div<IPlaygroundStyleProps>`
    ${p =>
        p.isLow &&
        css`
            transform: scale(0.55);
            margin-top: 120px;
        `}
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    top: 125px;
    pointer-events: none;

    img {
        width: 316px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    top: 200px;
    right: 0;
    pointer-events: none;
    img {
        width: 316px;
    }
`;
